<template>
    <div class="favourite-address" v-if="$store.getters.GET_PERSONAL_INFO.type === 'resident'" >
        <h5 class="mb-4 text-center" v-html="favouriteAddressHeader"></h5>
        <div class="favourite-address-loading-container d-flex justify-content-center">
            <loader-circle :classes="fetchLoadingClasses" />
        </div>
        <h6 v-if="$store.getters.GET_FAVORITES.fetched && $store.getters.GET_FAVORITES.list.length === 0" class="font-weight-bold text-center mt-4">{{ TEXTS.render(`FAVOURITE_ADDRESS_NONE`) }}</h6>
        <div class="text-error text-danger text-center mt-4">{{ errorFavoritefetch }}</div>
        <div :class="[($store.getters.GET_FAVORITES.list.length > 3) ? 'row d-flex flex-row justify-content-center' : 'row d-flex flex-row']" v-if="$store.getters.GET_FAVORITES.fetched">
        <FavouriteAddressItem v-for="(l, index) of $store.getters.GET_FAVORITES.list" :key="index" :index="index" :address="l">{{ index }}</FavouriteAddressItem>
        </div>
    </div>
</template>

<script>
    import LoaderCircle from '../../../../common/components/LoaderCircle';
    import FavouriteAddressItem from './FavouriteAddressItem';
    import helper from '../../../../helper'
    import Texts from '../../../../common/utils/Texts'

    export default {
        components: {
            LoaderCircle,
            FavouriteAddressItem
        },
        data() {
            return {
                fetchLoadingClasses: ['fetch-favorite-loading'],
                addressTooltip: '',
                window: {
                    width: 0,
                }
            }
        },
        mounted() {
            this.fetchLoadingClasses.push('loading-circle--show');
            this.$store.dispatch('getFavorites');
            // this.$store.dispatch('mainUI');
            // this.$store.dispatch('getSiteWordingsSettings');
        },
        computed: {
            TEXTS: ()=> Texts,
            loadingFavorites() {
                return this.$store.getters.GET_FAVORITES.loading
            },
            siteWordings() {
                return this.$store.getters['GET_SITE_WORDINGS']; 
            },
            errorFavoritefetch() {
                var error = this.$store.getters.GET_FAVORITES.error
                error = helper.reformatErrorMessage(error, 404, 'There was an error encountered while processing your request. Please try again. (Status code: 500)')
                return error
            },
            favouriteAddressHeader(){
                var favouriteAddressHeader = this.siteWordings ? this.siteWordings.fav_propertly_title : null
                return favouriteAddressHeader || Texts.render(`FAVOURITE_ADDRESS_HEADER`) 
            }
        },
        watch: {
            'loadingFavorites': function(loading) {
                if (!loading) {
                    this.fetchLoadingClasses.pop();
                }
            },
            'errorFavoritefetch': function(error) {
                if (error) {
                    this.fetchLoadingClasses.pop();
                }
            }
        }
    }
</script>